import useMediaQuery from 'hooks/useMediaQuery';

import { If } from '@mobi/components';

import CustomCarousel from 'components/CustomCarousel';

import './BenefitsWrapper.scss';

const BenefitsWrapper = ({ list, title }) => {
  const isDesktop = useMediaQuery('desktop');

  return (
    <section id="benefits-wrapper" className="benefits-wrapper container">
      <div className="benefits-wrapper__texts">
        <h1 className="benefits-wrapper__title">{title}</h1>
        <If
          condition={isDesktop}
          renderIf={
            <div className="benefits-wrapper__items">
              {list.map(({ image, title, subtitle }, index) => {
                return (
                  <div className="benefits-wrapper__card" key={index}>
                    <img
                      className="benefits-wrapper__image"
                      src={image}
                      alt={title}
                    />
                    <div className="benefits-wrapper__content">
                      <h3 className="benefits-wrapper__card-title">{title}</h3>
                      <h3 className="benefits-wrapper__card-subtitle">
                        {subtitle}
                      </h3>
                    </div>
                  </div>
                );
              })}
            </div>
          }
          renderElse={
            <CustomCarousel
              className="custom-carousel--content-section"
              data={list}
              variant={isDesktop}
              identifier="benefits-wrapper-carousel-info"
              renderItem={({ image, title, subtitle }, index) => {
                return (
                  <div className="benefits-wrapper__card" key={index}>
                    <img
                      className="benefits-wrapper__image"
                      src={image}
                      alt={title}
                    />
                    <div className="benefits-wrapper__content">
                      <h3 className="benefits-wrapper__card-title">{title}</h3>
                      <h3 className="benefits-wrapper__card-subtitle">
                        {subtitle}
                      </h3>
                    </div>
                  </div>
                );
              }}
            />
          }
        />
      </div>
    </section>
  );
};

export default BenefitsWrapper;
